// extracted by mini-css-extract-plugin
export default {"disableScroll":"TrSyzY","menu":"OjN5xa","active":"Te1XZB","overlay":"BokLBO","closeIcon":"C4usyu","innerIcon":"hVZbug","menuItems":"Ap9qhg"};